"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginStateFactory = void 0;
var loginStateFactory = function (config) { return (__assign({ isAuthenticated: false, isSigningIn: false, isLoaded: false, isLoggingOut: false }, config)); };
exports.loginStateFactory = loginStateFactory;
